import React, { useEffect, useState } from "react";
import "../Manage Projects/viewProjects.css";
import SearchBar from "../Main/searchBar";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import toast from "react-hot-toast";
import axios from "axios";
import { viewReferralCommission } from "../../Redux/Actions/referralCommissionAction";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ViewReferralCommission = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { referralCommission } = useSelector(
    (state) => state.referral_commission || {}
  );

  const [status, setStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(viewReferralCommission(id)).then((res) => {
        if (res?.data?.status) setStatus(res.data.status);
      });
    }
  }, [id, dispatch]);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setShowConfirm(true);
  };

  const confirmStatusChange = async () => {
    if (!id) {
      toast.error("Invalid referral commission ID");
      setShowConfirm(false);
      return;
    }
    setIsUpdating(true);
    setShowConfirm(false);
    try {
      await axios.post(`${BASE_URL}/referral-commission/update`, {
        id,
        status: selectedStatus,
      });
      toast.success("Status updated successfully!");
      setStatus(selectedStatus);
      const res = await dispatch(viewReferralCommission(id));
      if (res?.data?.status) setStatus(res.data.status);
    } catch (error) {
      toast.error("Error updating status");
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "minmax(60px, auto)",
      }}
      className="padding-20 gap-10 grid-container"
    >
      <div style={{ gridColumn: "2/8" }}>
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div
        className="back-icon margin-0 gap-10 align-center flex-container"
        style={{ gridColumn: "span 7" }}
      >
        <Link to="/referral_commission">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h3>
            {referralCommission?.data?.commission_name || "Referral Commission"}
          </h3>
          <h4 style={{ position: "relative", top: "-10px" }}>
            Referral Commission / List / View
          </h4>
        </div>
      </div>

      <div
        className="overall-container"
        style={{ opacity: isUpdating ? 0.6 : 1 }}
      >
        <div
          style={{ backgroundColor: "rgba(255, 255, 255, 0.16)" }}
          className="flex-container flex-justify-between border-24 align-center padding-20 flex-wrap"
        >
          {/* Country */}
          <div
            className="flex-container flex-column"
            style={{ minWidth: 200, margin: 10 }}
          >
            <span className="span-column" style={{ color: "#999" }}>
              Country
            </span>
            <h2 className="h2-column" style={{ color: "white" }}>
              {referralCommission?.data?.country?.country_name || "No Data"}
            </h2>
          </div>

          {/* State */}
          <div
            className="flex-container flex-column"
            style={{ minWidth: 200, margin: 10 }}
          >
            <span className="span-column" style={{ color: "#999" }}>
              State
            </span>
            <h2 className="h2-column" style={{ color: "white" }}>
              {referralCommission?.data?.state?.state_name || "No Data"}
            </h2>
          </div>

          {/* City */}
          <div
            className="flex-container flex-column"
            style={{ minWidth: 200, margin: 10 }}
          >
            <span className="span-column" style={{ color: "#999" }}>
              City
            </span>
            <h2 className="h2-column" style={{ color: "white" }}>
              {referralCommission?.data?.city?.city_name || "No Data"}
            </h2>
          </div>

          {/* Unit */}
          <div
            className="flex-container flex-column"
            style={{ minWidth: 200, margin: 10 }}
          >
            <span className="span-column" style={{ color: "#999" }}>
              Unit
            </span>
            <h2 className="h2-column" style={{ color: "white" }}>
              {referralCommission?.data?.unit || "No Data"}
            </h2>
          </div>

          {/* Referral Amount */}
          <div
            className="flex-container flex-column"
            style={{ minWidth: 200, margin: 10 }}
          >
            <span className="span-column" style={{ color: "#999" }}>
              Referral Amount
            </span>
            <h2 className="h2-column" style={{ color: "white" }}>
              {referralCommission?.data?.referral_amount ?? "No Data"}
            </h2>
          </div>

          {/* Status */}
          <div
            className="flex-container flex-column"
            style={{ minWidth: 200, margin: 10 }}
          >
            <span className="span-column" style={{ color: "#999" }}>
              Status
            </span>
            <h2 className="h2-column" style={{ color: "white" }}>
              {ToFirstCapital(referralCommission?.data?.status) || "No Data"}
            </h2>
          </div>

          {/* Created At */}
          <div
            className="flex-container flex-column"
            style={{ minWidth: 200, margin: 10 }}
          >
            <span className="span-column" style={{ color: "#999" }}>
              Created At
            </span>
            <h2 className="h2-column">
              {referralCommission?.data?.created_at
                ? DateToLocale(referralCommission.data.created_at)
                : "No Data"}
            </h2>
          </div>

          {/* Updated At */}
          <div
            className="flex-container flex-column"
            style={{ minWidth: 200, margin: 10 }}
          >
            <span className="span-column" style={{ color: "#999" }}>
              Updated At
            </span>
            <h2 className="h2-column">
              {referralCommission?.data?.updated_at
                ? DateToLocale(referralCommission.data.updated_at)
                : "No Data"}
            </h2>
          </div>
        </div>

        {/* Confirmation Modal */}
        {showConfirm && (
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "12px",
                minWidth: "300px",
                textAlign: "center",
              }}
            >
              <p>
                Are you sure you want to change status to "
                {selectedStatus.charAt(0).toUpperCase() +
                  selectedStatus.slice(1)}
                "?
              </p>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <button
                  onClick={confirmStatusChange}
                  disabled={isUpdating}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "8px",
                    cursor: isUpdating ? "not-allowed" : "pointer",
                    backgroundColor: "green",
                    color: "white",
                  }}
                >
                  Yes
                </button>
                <button
                  onClick={() => setShowConfirm(false)}
                  disabled={isUpdating}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "8px",
                    cursor: isUpdating ? "not-allowed" : "pointer",
                    backgroundColor: "red",
                    color: "white",
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewReferralCommission;
